import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
  TableHeaderBulkSelectCheckbox,
} from '@occc-app/design-system';
import { Location } from '@occc/graphql';
import {
  IPaginationProps,
  PaginationHandler,
  PaginationInfo,
} from '@occc-app/hooks/usePaginatedQuery';
import { useBulkSelect } from '@occc-app/hooks/useBulkSelect';

import LocationsTableItem from './locations-table-item.component';

type LocationsListProps = ReturnType<typeof useBulkSelect> & {
  loading: boolean;
  error?: ApolloError;
  data?: Location[];
  paginationProps: IPaginationProps;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
};

const LocationsTable = ({
  loading,
  error,
  data,
  paginationProps,
  bulkSelectedItems,
  handleBulkSelectMultiple,
  handleItemSelect,
}: LocationsListProps) => {
  const currentPageLocationUuids = data?.map((item) => item.uuid) || [];

  const renderData = (items: Location[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding='checkbox'>
              <TableHeaderBulkSelectCheckbox
                bulkSelectedItems={bulkSelectedItems}
                handleBulkSelectMultiple={handleBulkSelectMultiple}
                currentPageItems={currentPageLocationUuids}
              />
            </TableCell>
            <TableCell>Site ID</TableCell>
            <TableCell>Site Name (DBA)</TableCell>
            <TableCell>Site Address</TableCell>
            <TableCell>Site Phone Number</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((location) => (
            <LocationsTableItem
              location={location}
              key={location.uuid}
              isItemSelected={bulkSelectedItems.has(location.uuid)}
              handleItemSelect={handleItemSelect}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<Location> error={error} loading={loading} items={data} renderData={renderData} />
  );
};

export default LocationsTable;
